import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import miloObject from '../../../common/object';
import miloCookie from '../../../common/cookie';
import miloUrl from '../../../common/url';
import loginStatus from '../../../common/loginStatus';
import Platform from '../../../common/platform';
import loader from '../../../common/loader';
import Base64 from '../../../util/base64';
import { loginCookie, getWgAuthUrl } from '../common';
import { isFunction } from '../../../common/base';
import ATM from '../../../util/atm';
import { getGameId } from '../common';
import view from './view';
var mQQWxFrame = view.mQQWxFrame; // 通用配置

export var mobileParams = {
  /**
  * @cfg {object} oQQParams Pt QQ登录相关配置参数
  */
  oQQParams: {
    appId: '21000501',
    // 官网默认的pt登录appid
    sUrl: '' // 登录之后的跳转地址

  },

  /**
  * @cfg {object} oWXParams 微信登录相关配置参数
  */
  oWXParams: {
    appId: 'wx1cd4fbe9335888fe',
    // 游戏在微信的appid，默认为腾讯游戏活动号
    gameDomain: 'iu.qq.com',
    redirectUri: '',
    // 授权页面，默认为系统默认的comm-htdocs/login/milosdk/wx_mobile_redirect.html
    sUrl: '',
    // 授权成功返回的页面，默认为当前页面
    scope: 'snsapi_base',
    // 默认静默授权
    lang: 'zh_CN',
    // 返回的用户信息中省市的语言版本
    openlink: '' // openlink，如果设置了，则在处理微信登录的时候，会从第三方跳到微信中

  },

  /**
  * @cfg {object} oQQConnectParams QQ互联登录方式相关参数
  */
  oQQConnectParams: {
    appId: '101491592',
    scope: 'get_user_info',
    state: 'STATE',
    redirectUri: 'https://milo.qq.com/comm-htdocs/login/qc_redirect.html',
    sUrl: '' // 登录之后的跳转地址

  },

  /**
  * @cfg {object} oWegameParams wegame互联登录方式相关参数
  */
  oWegameParams: {
    clientId: '7019928239',
    // 应用id
    redirectUri: 'https://milo.qq.com/comm-htdocs/login/wegame_redirect.html',
    // 回调地址
    railGameId: '2000108',
    // 游戏id
    scope: 'openid profile',
    // 作用域，可多选，空格分隔
    state: 'STATE',
    // 防csrf
    lang: 'ZH_CN',
    // 语言，默认为中文(ZH_CN)
    extraParams: {}
  },

  /**
    *@cfg {object} oKsParams 快手登录方式相关参数
    */
  oKsParams: {
    appId: 'ks696650568893170628',
    // appId
    sUrl: '',
    // 跳转地址
    scope: 'user_info' // 授权范围

  }
};
export var loginByQQ_Mobile = function loginByQQ_Mobile() {
  var loginParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (1 === loginParams.iUseQQConnect) {
    // 互联登录
    loginByQQConnect_Mobile(loginParams);
    return;
  }

  try {
    ATM.reportATM({
      toappid: 38,
      tomoduletype: 21,
      tointer: 1,
      businesstype: getGameId(),
      toreturncode: 0,
      result: 0,
      cgi: location.href,
      errormsg: 'pt jump',
      serialtime: parseInt(new Date().getTime() / 1000)
    });
  } catch (error) {
    console.log(error);
  }

  var s_url = loginParams.sUrl ? loginParams.sUrl : location.href;
  var sData = 'undefined';

  if (loginParams.sData) {
    sData = miloObject.serialize(loginParams.sData);
  }

  var param = {
    s_url: s_url,
    sData: sData,
    logo: loginParams.logo,
    jump_window: loginParams.jumpWin
  };
  window.location = "".concat(location.protocol, "//").concat(window.location.host, "/comm-htdocs/login/milosdk/login.html?").concat(miloObject.serialize(param));
};
export var loginByQQConnect_Mobile = function loginByQQConnect_Mobile() {
  var loginParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // 跳转url
  loginParams.sUrl = loginParams.sUrl || location.href;
  var appId = loginParams.appId,
      state = loginParams.state;
  var redirectUri = loginParams.redirectUri,
      sUrl = loginParams.sUrl;
  sUrl = Base64.encode(sUrl || location.href);

  if (redirectUri) {
    if (redirectUri.indexOf('appid=') < 0) {
      redirectUri += "".concat(redirectUri.indexOf('?') > -1 ? '&' : '?', "appid=").concat(appId);
    }

    if (redirectUri.indexOf('s_url=') < 0) {
      redirectUri += "".concat(redirectUri.indexOf('?') > -1 ? '&' : '?', "s_url=").concat(sUrl);
    }
  }

  if (!redirectUri) {
    redirectUri = "https://milo.qq.com/comm-htdocs/login/qc_redirect.html?parent_domain=".concat(encodeURIComponent("".concat(location.protocol, "//").concat(location.host)), "&appid=").concat(appId, "&s_url=").concat(sUrl);
  }

  var loginOpt = {
    state: state,
    client_id: appId,
    redirect_uri: redirectUri
  }; // redirect_uri  为透传页面

  if (-1 == loginOpt.redirect_uri.indexOf('parent_domain=')) {
    loginOpt.redirect_uri += "".concat(loginOpt.redirect_uri.indexOf('?') > -1 ? '&' : '?', "parent_domain=").concat(encodeURIComponent("".concat(location.protocol, "//").concat(location.host)));
  } // 后台配置的redirect_uri


  loginOpt.redirect_uri += "".concat(loginOpt.redirect_uri.indexOf('?') > -1 ? '&' : '?', "redirect_uri=").concat(encodeURIComponent(redirectUri)); // 增加milosdk标识

  loginOpt.redirect_uri += '&isMiloSDK=1';
  loginCookie.setLocal({
    qclogin_state: state
  }, 86400);
  var loginUrl = "https://graph.qq.com/oauth2.0/authorize?response_type=code&".concat(miloObject.serialize(loginOpt));
  location.href = loginUrl;
};
export var loginByWX_Mobile = function loginByWX_Mobile() {
  var loginParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sUrl = loginParams.sUrl,
      redirectUri = loginParams.redirectUri;
  var appId = loginParams.appId,
      gameDomain = loginParams.gameDomain,
      scope = loginParams.scope,
      openlink = loginParams.openlink,
      forcePopup = loginParams.forcePopup;

  if (!sUrl) {
    sUrl = location.href;
  } // 处理s_url 跳转url


  var href = sUrl.replace(/#.*/, ''); // 去掉href中的code参数

  if (href.indexOf('?code=') > -1) {
    href = href.replace(/\?code=[^&.]*(&|$)/, '?');
  } else if (href.indexOf('&code=') > -1) {
    href = href.replace(/&code=[^&.]*(&|$)/, '&');
  } // 如果href以字符?或&结尾则去掉


  if (/(\?|&)$/.test(href)) {
    href = href.substring(0, href.length - 1);
  }

  var hrefHash = sUrl.match(/#.*/) && sUrl.match(/#.*/)[0] || ''; // redirect_uri  授权uri

  if (!redirectUri) {
    redirectUri = "https://".concat(gameDomain || location.host, "/comm-htdocs/login/milosdk/wx_mobile_redirect.html?acctype=wx&appid=").concat(appId, "&s_url=").concat(encodeURIComponent(href + hrefHash));
  } // 判断环境


  if (Platform.isWxApp()) {
    // 微信内
    var redirect_url_wx = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=".concat(appId, "&redirect_uri=").concat(encodeURIComponent(redirectUri), "&response_type=code&scope=").concat(scope, "&state=STATE");

    if (forcePopup) {
      window.location.href = "".concat(redirect_url_wx, "&forcePopup=true&forceSnapShot=true#wechat_redirect");
    } else {
      window.location.href = "".concat(redirect_url_wx, "#wechat_redirect");
    }
  } else {
    //
    if (openlink) {
      location.href = openlink;
    } else {
      alert('请在微信内打开');
    }
  }
};
/**
    微信委托授权登录
    opt说明:
    {
        fromAppId:'',//被委托方微信appid
        fromDomain:''//被委托方的微信appid授权对应的回调域名，默认为当前页面域名
        toAppId:'',//委托方微信appid
        toDomain:'',//委托方微信appid委托授权对应的回调域名
        targetUrl:'',//最终携带milo_delegate_code跳转的页面,如果不传则为当前页面
        backUrl:''//出现错误时回退的url，默认为当前页
    }
    */

export var loginByWxDelegate = function loginByWxDelegate(opt) {
  var _ref = opt || {},
      fromAppId = _ref.fromAppId,
      fromDomain = _ref.fromDomain,
      toAppId = _ref.toAppId,
      toDomain = _ref.toDomain;

  var _ref2 = opt || {},
      targetUrl = _ref2.targetUrl,
      backUrl = _ref2.backUrl; // 需要在微信内打开


  if (!Platform.isWxApp()) {
    console.warn && console.warn('第三方浏览器，请使用openlink跳转到微信内，再登录~');
    return;
  }

  if (!fromAppId) {
    console.warn && console.warn('委托授权缺少必要参数:fromAppId');
    return;
  }

  if (!toAppId) {
    console.warn && console.warn('委托授权缺少必要参数:toAppId');
    return;
  }

  if (!toDomain) {
    console.warn && console.warn('委托授权缺少必要参数:toDomain');
    return;
  }

  if (!targetUrl) {
    targetUrl = location.href;
  }

  if (!backUrl) {
    backUrl = location.href;
  }

  function getRealUrl(redirect_uri) {
    var href = redirect_uri.replace(/#.*/, ''); // 去掉href中的code参数

    if (href.indexOf('?code=') > -1) {
      href = href.replace(/\?code=[^&.]*(&|$)/, '?');
    } else if (href.indexOf('&code=') > -1) {
      href = href.replace(/&code=[^&.]*(&|$)/, '&');
    }

    if (/(\?|&)$/.test(href)) {
      href = href.substring(0, href.length - 1);
    }

    var hrefHash = targetUrl.match(/#.*/) && targetUrl.match(/#.*/)[0] || '';
    return href + hrefHash;
  } // step=1表示本次进行的是被委托方自身业务授权，step=2表示委托方委托授权


  var sUrl = "".concat(location.protocol, "//").concat(fromDomain || location.host, "/comm-htdocs/login/wxdelegate.html?step=1&fromAppId=").concat(fromAppId, "&toAppId=").concat(toAppId, "&toDomain=").concat(toDomain, "&targetUrl=").concat(encodeURIComponent(getRealUrl(targetUrl)), "&backUrl=").concat(encodeURIComponent(getRealUrl(backUrl)));
  var miloDelegateState = "".concat(Math.ceil(Math.random() * 10000));
  miloCookie.set('milo_delegate_state', miloDelegateState, 600, 'qq.com', '/');
  window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=".concat(fromAppId, "&redirect_uri=").concat(encodeURIComponent(sUrl), "&response_type=code&scope=snsapi_userinfo&state=").concat(miloDelegateState, "&connect_redirect=1#wechat_redirect");
};
export var loginByWegame_Mobile = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var wegameParams,
        wgauth,
        wgOneAuth,
        sUserAgent,
        REGEXP_IOS_QQ,
        isIphoneOs_QQ,
        loginOpt,
        loginUrl,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            wegameParams = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            wgauth = wegameParams.wgauth; // 是否开启一键登录

            wgOneAuth = wgauth == 1 || miloUrl.request('wgauth') == 1; // 即通给的正则表达式

            sUserAgent = navigator.userAgent;
            REGEXP_IOS_QQ = new RegExp('(iPad|iPhone|iPod).*? (IPad)?QQ\\/([\\d\\.]+)');
            isIphoneOs_QQ = REGEXP_IOS_QQ.test(sUserAgent);
            wegameParams.hide_login_box = isIphoneOs_QQ ? 1 : 0; // extraParams

            if (!wegameParams.extraParams.s_url) {
              wegameParams.extraParams.s_url = location.href;
            }

            wegameParams.extraParams.client_id = wegameParams.clientId;
            wegameParams.extraParams.state = wegameParams.state;
            wegameParams.extraParams.redirect_uri = wegameParams.redirectUri;
            wegameParams.extraParams.isMiloSDK = 1;
            loginOpt = {
              browser_type: 2,
              // mobile
              // redirect_type:'self',
              state: Base64.encode(miloObject.serialize(wegameParams.extraParams)),
              // state负责将extraParams带到后台
              client_id: wegameParams.clientId,
              rail_game_id: wegameParams.railGameId,
              lang: wegameParams.lang,
              scope: wegameParams.scope,
              redirect_uri: wegameParams.redirectUri,
              hide_login_box: wegameParams.hide_login_box
            }; // parent domain

            miloCookie.set('milo_wegame_domain', "https://".concat(location.host), 600, 'qq.com', '/'); // state

            miloCookie.set('wegamelogin_state', wegameParams.extraParams.state, 600, location.host, '/');
            loginUrl = "https://api.rail.tgp.qq.com/web/oauth2.0/login/authorize?response_type=code&".concat(miloObject.serialize(loginOpt));

            if (!wgOneAuth) {
              _context.next = 27;
              break;
            }

            _context.prev = 17;
            _context.next = 20;
            return getWgAuthUrl(wegameParams);

          case 20:
            loginUrl = _context.sent;
            loginUrl = "".concat(loginUrl).concat(loginUrl.indexOf('?') > -1 ? '&' : '?', "state=").concat(Base64.encode(miloObject.serialize(wegameParams.extraParams)));
            _context.next = 27;
            break;

          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](17);
            console.log('获取wegame一键登录授权url失败');

          case 27:
            // 跳转
            location.href = loginUrl;

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[17, 24]]);
  }));

  return function loginByWegame_Mobile() {
    return _ref3.apply(this, arguments);
  };
}();
export var loginByQQAndWX_Mobile = function loginByQQAndWX_Mobile() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var self = this;
  var oQQParams = opt.oQQParams,
      oWXParams = opt.oWXParams,
      fBeforeWXLogin = opt.fBeforeWXLogin,
      fBeforeQQLogin = opt.fBeforeQQLogin;
  var autoCheckPlat = opt && opt.autoCheckPlat;
  autoCheckPlat = typeof autoCheckPlat === 'undefined' ? true : opt.autoCheckPlat; // 默认开启

  if (autoCheckPlat) {
    if (Platform.isQQApp()) {
      loginByQQ_Mobile.call(self, oQQParams);
      return;
    }

    if (Platform.isWxApp()) {
      loginByWX_Mobile.call(self, oWXParams);
      return;
    }
  }

  mQQWxFrame.init(function () {
    mQQWxFrame.oWXParams = oWXParams;
    mQQWxFrame.oQQParams = oQQParams;
    mQQWxFrame.fBeforeWXLogin = fBeforeWXLogin;
    mQQWxFrame.fBeforeQQLogin = fBeforeQQLogin;

    mQQWxFrame.loginByQQ = function () {
      loginByQQ_Mobile.call(self, oQQParams);
    };

    mQQWxFrame.loginByWX = function () {
      loginByWX_Mobile.call(self, oWXParams);
    };

    mQQWxFrame.show();
  }, self);
};
export var loginByQCAndWX_Mobile = function loginByQCAndWX_Mobile() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var self = this;
  var oQQConnectParams = opt.oQQConnectParams,
      oWXParams = opt.oWXParams,
      fBeforeWXLogin = opt.fBeforeWXLogin,
      fBeforeQQLogin = opt.fBeforeQQLogin;

  if (oQQConnectParams) {
    oQQConnectParams.iUseQQConnect = 1;
  }

  var autoCheckPlat = opt && opt.autoCheckPlat;
  autoCheckPlat = typeof autoCheckPlat === 'undefined' ? true : opt.autoCheckPlat; // 默认开启

  if (autoCheckPlat) {
    if (Platform.isQQApp()) {
      loginByQQ_Mobile.call(self, oQQConnectParams);
      return;
    }

    if (Platform.isWxApp()) {
      loginByWX_Mobile.call(self, oWXParams);
      return;
    }
  }

  mQQWxFrame.init(function () {
    mQQWxFrame.oWXParams = oWXParams;
    mQQWxFrame.oQQParams = oQQConnectParams;
    mQQWxFrame.fBeforeWXLogin = fBeforeWXLogin;
    mQQWxFrame.fBeforeQQLogin = fBeforeQQLogin;

    mQQWxFrame.loginByQQ = function () {
      loginByQQ_Mobile.call(self, oQQConnectParams);
    };

    mQQWxFrame.loginByWX = function () {
      loginByWX_Mobile.call(self, oWXParams);
    };

    mQQWxFrame.show();
  }, self);
};
export var loginByKs_Mobile = function loginByKs_Mobile() {
  var logOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!logOption.sUrl) {
    logOption.sUrl = location.href;
  }

  var sDealUrl = "https://".concat(location.host, "/comm-htdocs/login/ks_redirect.html");
  miloCookie.set('ks_s_url', logOption.sUrl, 300, location.host, '/');
  miloCookie.set('ks_tmp_appid', logOption.appId, 300, location.host, '/'); // milo处理中转逻辑
  // 快手中转页，做codeToOpenId操作

  var redirectUri = "https://open.kuaishou.com/game/login?platform=ks&app_id=".concat(logOption.appId, "&redirect=").concat(sDealUrl);
  var loginUrl = "https://open.kuaishou.com/oauth2/authorize?app_id=".concat(logOption.appId, "&response_type=code&scope=").concat(logOption.scope, "&redirect_uri=").concat(encodeURIComponent(redirectUri));
  location.href = loginUrl;
};
export var refreshWegame_Mobile = function refreshWegame_Mobile(successCallback, failCallback) {
  var refresh_token = miloCookie.get('refresh_token');
  var appid = miloCookie.get('appid');
  var acctype = miloCookie.get('acctype');

  if (!refresh_token || !appid || 'wg' != acctype) {
    isFunction(failCallback) && failCallback('抱歉，请重新登录。');
    return;
  }

  var loginUrl = "".concat(location.protocol, "//ams.game.qq.com/ams/userLoginSvr");
  var wegameRefreshCbName = "wegameRefresh_".concat(Math.ceil(10000 * Math.random()));

  window[wegameRefreshCbName] = function (retObj) {
    if (0 == retObj.errorCode && retObj.isLogin) {
      var expires_in = retObj.expires_in || 3600;
      var openid = retObj.openid,
          access_token = retObj.access_token,
          _refresh_token = retObj.refresh_token;
      loginCookie.setLocal({
        openid: openid,
        access_token: access_token
      }, expires_in);
      loginCookie.setLocal({
        refresh_token: _refresh_token
      }, 86400);
      isFunction(successCallback) && successCallback();
    } else {
      isFunction(failCallback) && failCallback(retObj.errorStr);
    }
  };

  var params = {
    appid: appid,
    acctype: acctype,
    refresh_token: refresh_token,
    callback: wegameRefreshCbName
  };
  loginStatus.clearAME(function () {
    loader.loadScript("".concat(loginUrl, "?").concat(miloObject.serialize(params)), function () {});
  });
};